//packages block
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { FC, useContext, useEffect } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
// component block
import { Alert } from "../common/Alert";
import { CustomController } from "../common/CustomController";
// others
import { ForgotPasswordInput, useForgotPasswordMutation } from "../../../generated";
import { AUTH_LINKS, AUTH_TOKEN, BACK_TO_LOGIN, CASE_ROUTE, DASHBOARD_ROUTE, FORBIDDEN_EXCEPTION, FORGET_PASSWORD_SUCCESS, NOT_FOUND_EMAIL_MESSAGE, SEND_INSTRUCTION } from "../../constants";
import { AuthContext } from "../../context";
import { forgotPasswordValidationSchema } from "../../validationSchema";

export const ForgotPasswordForm: FC = (): JSX.Element => {
  const { isInvestigator } = useContext(AuthContext)
  const navigate = useNavigate()

  const methods = useForm({
    mode: "all",
    resolver: yupResolver(forgotPasswordValidationSchema),

    defaultValues: {
      email: ''
    }
  });

  const { handleSubmit, reset } = methods;
  const [forgotPassword, { loading }] = useForgotPasswordMutation({
    onError({ message }) {
      if (message.toLowerCase() === FORBIDDEN_EXCEPTION)
        return Alert.error(NOT_FOUND_EMAIL_MESSAGE)
    },

    onCompleted(data) {
      if (data) {
        const { forgotPassword: { response } } = data

        if (response) {
          const { status } = response

          if (status === 404) {
            return Alert.error(NOT_FOUND_EMAIL_MESSAGE);
          }

          if (status === 200) {
            Alert.success(FORGET_PASSWORD_SUCCESS)
            reset()
          }
        }
      }
    }
  })

  useEffect(() => {
    localStorage.getItem(AUTH_TOKEN) && navigate(isInvestigator ? CASE_ROUTE : DASHBOARD_ROUTE)
    // eslint-disable-next-line
  }, []);

  const onSubmit: SubmitHandler<ForgotPasswordInput> = async (data: ForgotPasswordInput) => {
    await forgotPassword({
      variables: {
        forgotPasswordInput: data
      },
    });
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <CustomController
          controllerName='email'
          controllerLabel='Email'
          fieldType='email'
        />

        <Box marginBottom='20px'>
          <Typography component={Link} to={AUTH_LINKS.LOGIN_LINK} color="primary" variant="subtitle1" sx={{ textDecoration: 'underline' }}>
            {BACK_TO_LOGIN}
          </Typography>
        </Box>

        <Button variant="contained" type="submit" fullWidth color="primary" disabled={loading} aria-label={SEND_INSTRUCTION}
          endIcon={loading && <CircularProgress size={20} color="inherit" />}>
          {SEND_INSTRUCTION}
        </Button>
      </form>
    </FormProvider>
  )
}